module.exports = __webpack_public_path__ + "static/media/treatment.8b79e6c7.jpg";